<style lang="less"></style>

<template>
  <div class="newgraph-page">
    <NewGraph></NewGraph>
  </div>
</template>

<script>
// @ is an alias to /src
import NewGraph from "@/components/home/NewGraph";

export default {
  name: "newgraph",
  components: {
    NewGraph
  }
};
</script>
